// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"587":"fdb72ad7","822":"c7f0b556","835":"7d6037d2"}[chunkId] + ".chunk.js";
};